// base in 2.2.1
import Dropdown from './Dropdown'
export default Dropdown



// WEBPACK FOOTER //
// ./components/vc-dropdown/src/index.js